import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AddGreetingCategoryTag from "./add";
import ListGreetingCategory from "./list";

const Main = ({ match }) => (
<Switch>
      <Route path={`${match.url}/add`} component={AddGreetingCategoryTag} />
      <Route path={`${match.url}/edit/:id`} component={AddGreetingCategoryTag} />
      <Route path={`${match.url}/list`} component={ListGreetingCategory} />      
      <Route exact path={`${match.url}/`}>
        <Redirect to={`${match.url}/list`} />
      </Route>
    </Switch>
);

export default Main;
